"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";

interface CreationReadyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: () => void;
}

const CreationReadyModal: React.FC<CreationReadyModalProps> = ({
  isOpen,
  onClose,
  onNavigate,
}) => {
  const handleNavigate = () => {
    onClose();
    onNavigate();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white/10 backdrop-blur-2xl border border-white/20 rounded-2xl p-8 max-w-sm w-full shadow-2xl text-white text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-green-400/20 rounded-full flex items-center justify-center border-2 border-green-400">
                <Sparkles size={32} className="text-green-400" />
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-2">Creation Ready!</h2>
            <p className="text-white/80 mb-6">
              Your new creation is ready for editing.
            </p>
            <div className="flex flex-col gap-3">
              <motion.button
                onClick={handleNavigate}
                className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white font-bold py-3 rounded-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Start Editing
              </motion.button>
              <motion.button
                onClick={onClose}
                className="w-full bg-white/10 py-3 rounded-lg font-medium"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Later
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CreationReadyModal;